////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const initKioskCreationSummary = {
	resetDataSummary: () => ({
		type: ActionsTypes.RESET_DATA_CREATION_SUMMARY,
	}),
	getSummaryCustomer: (id) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_SUMMARY_CUSTOMER,
		payload: {
			id,
		},
	}),
	getSummaryCustomerSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_SUMMARY_CUSTOMER_SUCCESS,
		payload: {
			data,
		},
	}),
	getSummaryCustomerFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_SUMMARY_CUSTOMER_FAILURE,
		payload: {
			error,
		},
	}),
	setSummaryConfigFinishedCustomer: (requestId) => ({
		type: ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_CUSTOMER,
		payload: {
			requestId,
		},
	}),
	setSummaryConfigFinishedCustomerSuccess: (data) => ({
		type: ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_CUSTOMER_SUCCESS,
		payload: {
			data,
		},
	}),
	setSummaryConfigFinishedCustomerFailure: (error) => ({
		type: ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_CUSTOMER_FAILURE,
		payload: {
			error,
		},
	}),
	getSummaryBusiness: (id) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_SUMMARY_BUSINESS,
		payload: {
			id,
		},
	}),
	getSummaryBusinessSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_SUMMARY_BUSINESS_SUCCESS,
		payload: {
			data,
		},
	}),
	getSummaryBusinessFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_SUMMARY_BUSINESS_FAILURE,
		payload: {
			error,
		},
	}),
	setSummaryConfigFinishedBusiness: (requestId) => ({
		type: ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_BUSINESS,
		payload: {
			requestId,
		},
	}),
	setSummaryConfigFinishedBusinessSuccess: (data) => ({
		type: ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_BUSINESS_SUCCESS,
		payload: {
			data,
		},
	}),
	setSummaryConfigFinishedBusinessFailure: (error) => ({
		type: ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_BUSINESS_FAILURE,
		payload: {
			error,
		},
	}),
	setSummaryTriggerBuild: (requestId) => ({
		type: ActionsTypes.SET_SUMMARY_TRIGGER_BUILD,
		payload: {
			requestId,
		},
	}),
	setSummaryTriggerBuildSuccess: (data) => ({
		type: ActionsTypes.SET_SUMMARY_TRIGGER_BUILD_SUCCESS,
		payload: {
			data,
		},
	}),
	setSummaryTriggerBuildFailure: (error) => ({
		type: ActionsTypes.SET_SUMMARY_TRIGGER_BUILD_FAILURE,
		payload: {
			error,
		},
	}),
}

export default initKioskCreationSummary
